import { render, staticRenderFns } from "./DlgSalesView.vue?vue&type=template&id=5bc5f100&scoped=true"
import script from "./DlgSalesView.vue?vue&type=script&lang=js"
export * from "./DlgSalesView.vue?vue&type=script&lang=js"
import style0 from "./DlgSalesView.vue?vue&type=style&index=0&id=5bc5f100&prod&lang=scss"
import style1 from "./DlgSalesView.vue?vue&type=style&index=1&id=5bc5f100&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc5f100",
  null
  
)

export default component.exports